import { apiService } from "api/apiService";
import type {
  PortfolioStudentProgressGroupedResource,
  FilterResource,
} from "api/generated";
import { studentProgressGroupedFromDto } from "portfolio/api/mappers";
import { mapFilters } from "shared/mappers/filter.mapper";
import type { MyStudentsProgress } from "portfolio/types";
import type { Filter } from "shared/types";

export const fetchMyLessongroups = async (
  params: Record<string, string> = {},
): Promise<MyStudentsProgress> => {
  const { data } =
    await apiService.get<PortfolioStudentProgressGroupedResource>(
      "api/portfolio/my-lessongroups",
      { params },
    );

  return studentProgressGroupedFromDto(data);
};

export const fetchMyLessongroupsFilters = async (): Promise<Filter[]> => {
  const {
    data: { data: filters },
  } = await apiService.get<{ data: FilterResource[] }>(
    "api/portfolio/my-lessongroups/filters",
  );

  return mapFilters(filters);
};
